
<template>
    
        <mars-view :style="{
        'z-index': zIndex,
        'margin': rowTile ? rowTileMargin : ''
    }" class="tag-layout"><c-filter-tag-layout :options="mSelections" :primary-color="primaryColor" :selected-index="selectedIndex" :selected-item-bold="selectedItemBold" :item-select-strategy="itemSelectStrategy" :padding-horizontal="filterTagLayoutPaddingHorizontal" border-bottom class="filter-tag-layout" @taglayouttap="handleTagLayoutTap"></c-filter-tag-layout><mars-view :style="{
            'z-index': zIndex
        }" class="wrapper"><template v-for="(selection, selectionIndex) in mSelections"><c-cascader v-if="selection.type === 'list'" :key="selectionIndex" :column="selection.column" :column-width-ratio="selection.columnWidthRatio" :options="selection.options" :v-key="selection.key" :default-value="selection.defaultValue" :default-value-type="selection.defaultValueType" :selected-color="primaryColor" :primary-color="primaryColor" :max-height="
                    maxHeight <= 1
                        ? windowHeight * maxHeight + 'px'
                        : maxHeight + 'px'
                " :height="height
                    ? height <= 1
                        ? windowHeight * height + 'px'
                        : height + 'px'
                    : 'auto'
                " :stop-scroll-through="stopScrollThrough" :class="
                    selectionIndex === selectedIndex
                        ? ''
                        : 'hidden'
                " @itemtap="handleCascaderItemTap($event, {
                    selection
                })" @lastcolumnitemtap="handleLastColumnItemTap"></c-cascader><mars-view v-if="selection.type === 'multi'" :key="selectionIndex" :class="
                    selectionIndex === selectedIndex
                        ? ''
                        : 'hidden'
                " :style="{
                    maxHeight: maxHeight <= 1
                        ? windowHeight * maxHeight + 'px'
                        : maxHeight + 'px',
                    height: height
                        ? height <= 1
                            ? windowHeight * height + 'px'
                            : height + 'px'
                        : 'auto'
                }" class="multi-wrapper"><mars-view ref="multi" :style="{
                        maxHeight: maxHeight <= 1
                            ? windowHeight * maxHeight + 'px'
                            : maxHeight + 'px',
                        height: height
                            ? height <= 1
                                ? windowHeight * height + 'px'
                                : height + 'px'
                            : 'auto'
                    }" class="multi" @touchstart.native="handleMultiTouchStart" @touchmove.native="handleMultiTouchMove"><template v-for="(option, optionIndex) in selection.options"><mars-view :key="optionIndex" class="c-padding-h"><c-tags :selected-index="option.selectedIndex" :options="option.options" :label="option.label" :type="option.type" :background-color-selected="selection.backgroundColorSelected" :border-radius="selection.borderRadius" :primary-color="primaryColor" :selected-bold="selection.selectedBold" :selected-icon="selection.selectedIcon" @itemtap="handleItemTap($event, {
                                    selection,
                                    selectionIndex,
                                    option,
                                    optionIndex
                                })"></c-tags></mars-view></template></mars-view><mars-view class="btn-layout c-font-medium" @touchmove.native.prevent><mars-view class="c-row"><mars-view :class="
                                'c-span' + (selection.resetBtnCol
                                    ? selection.resetBtnCol
                                    : 4)
                            "><c-btn :disabled="!selection.isCanReset" :primary-color="primaryColor" :border-radius="selection.borderRadius" @click.native="handleMultiResetTap({
                                    selection,
                                    selectionIndex
                                })">
                                重置
                            </c-btn></mars-view><mars-view :class="
                                'c-span' + (selection.confirmBtnCol
                                    ? selection.confirmBtnCol
                                    : 8)
                            "><c-btn :border-radius="selection.borderRadius" type="primary" :primary-color="primaryColor
                                    ? primaryColor
                                    : '#5183FF'" @click.native="handleMultiConfirmTap">
                                确定
                            </c-btn></mars-view></mars-view></mars-view></mars-view></template><mars-view v-if="selectedIndex !== -1 && showMask" :style="{
                backgroundColor: maskColor
            }" class="mask" @click.native="handleMaskTap" @touchmove.native.prevent></mars-view></mars-view></mars-view>
    
</template>

<script>
import FilterTagLayout from "../FilterTagLayout/FilterTagLayout.vue";
import Cascader from "../Cascader/Cascader.vue";
import Tags from "../Tags/Tags.vue";
import Button from "../Button/Button.vue";
import stopScrollThroughMixin from '../../mixins/stopScrollThroughMixin';
export default {
  mixins: [stopScrollThroughMixin],
  components: {
    'c-filter-tag-layout': FilterTagLayout,
    'c-cascader': Cascader,
    'c-tags': Tags,
    'c-btn': Button
  },
  props: {
    /**
     * 选项们
     *
     * @property {string} type='list' 筛选项的类型：`list`（级联类型），`multi`（复合类型）、`order`（排序类型）
     * @property {string} text 筛选项标签的文案
     * @property {string} key 筛选项的唯一标识；仅支持 `list`、`order` 类型
     * @property {string} defaultValue 当前筛选项的默认值；仅支持 `list`、`order` 类型
     * @property {number} column=1 当前级联筛选的级数（或者叫列数）；仅支持 `list` 类型
     * @property {Array} columnWidthRatio=[1, 2] 当前级联筛选的列数宽度比值数组；仅支持 `list` 类型
     * @property {boolean} hideBtnLayout=false 是否隐藏按钮栏；仅支持 `multi` 类型
     * @property {string} backgroundColorSelected 被选中后的背景色；仅支持 `multi` 类型
     * @property {string} borderRadius 选项的圆角弧度；仅支持 `multi` 类型
     * @property {boolean} selectedBold 被选中是否要加粗；仅支持 `multi` 类型
     * @property {boolean} selectedIcon 被选中是否要显示图标；仅支持 `multi` 类型
     * @property {number} resetBtnCol=4 重置按钮栅格数；仅支持 `multi` 类型
     * @property {number} confirmBtnCol=8 确认按钮栅格数；仅支持 `multi` 类型
     *
     * @property {Array} options 当前筛选项的子选项们
     * @property {string} options[].text 子选项的文案
     * @property {string} options[].value 子选项的值
     * @property {string} options[].extend 子选项的扩展说明
     * @property {string} options[].key 当前子选项的唯一标识
     * @property {string} options[].defaultValue 当前子选项的默认值，多个选项需要用`,`分隔开
     * @property {string} options[].label 子选项的标签；仅支持 `multi` 类型
     * @property {boolean} options[].noSpread 子选项大于3个是否不需要展开收起，默认为 false
     * @property {string} options[].type='radio' 子选项的类型；仅支持 `multi` 类型：`radio`（单选框）、`checkbox`（多选框）、`rangeInput`（范围输入框）
     * @property {boolean} options[].forceCheck=false 是否不论单选多选都强制使用箭头选中样式；这里的背景是，单选和多选的标签样式，其实单选是不带右下角箭头的，多选是带的，但这里需求需要单选样式也带箭头，所以会有这个属性，强行让单选也变成有箭头
     * @property {boolean} options[].size=large 设置多选按钮的大小：'large' 大按钮，'normal' 正常按钮
     * @property {string} options[].icon 第二级选项的图标，仅支持 `multi` 类型
     * @property {Array} options[].options 子选项的子选项们，与`selections[].options`完全一致，仅支持 `list` 类型，多级级联时使用
     *
     * @property {object} options[].input 输入框配置；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     * @property {string} options[].input.unit 输入框单位；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     * @property {object} options[].input.min 最小值配置；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     * @property {string} options[].input.min.placeholder 最小值 placeholder；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     * @property {object} options[].input.max 最大值配置；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     * @property {string} options[].input.max.placeholder 最大值 placeholder；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     * @property {string} options[].input.errorTips='错误提示' 输入错误提示信息；仅支持 `multi` 类型，`rangeInput`（范围输入框）
     */
    selections: Array,

    /**
     * z-index
     */
    zIndex: {
      type: Number,
      default: 1
    },

    /**
     * 水平切换动效
     */
    horizontalTransition: {
      type: Boolean,
      default: false
    },

    /**
     * 透明度动效
     */
    opacityTransition: {
      type: Boolean,
      default: false
    },

    /**
     * 动效配置
     */
    transitionOpts: {
      type: Object,
      default: function () {
        return {
          // 下滑动效
          downTransition: 'all .3s cubic-bezier(0.42, 0, 0.52, 1)',
          // 上滑动效
          upTransition: 'all .16s cubic-bezier(0.46, 0, 1, 1)',
          // height 高度变化动效参数
          heightTransition: 'height .3s cubic-bezier(0.4, 0.0, 0.2, 1)',
          // 内容 item 左右动效参数
          horizontalTransition: 'left .24s cubic-bezier(.18,.74,.78,.96),opacity .5s cubic-bezier(.18,0,.26,1)',
          // 透明度渐变动效
          opacityTransition: 'opacity .08s cubic-bezier(0,0,1,1)'
        };
      }
    },

    /**
     * 背景颜色
     */
    backgroundColor: {
      type: String,
      default: '#fff'
    },

    /**
     * 是否阻止滚动穿透；如果在结果页里使用，则不建议阻止
     */
    stopScrollThrough: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示蒙层；如果在结果页里使用，则建议不显示
     */
    showMask: {
      type: Boolean,
      default: true
    },

    /**
     * 蒙层颜色；默认为 rgba(0, 0, 0, .65)
     */
    maskColor: {
      type: String,
      default: 'rgba(0, 0, 0, .65)'
    },

    /**
     * 主颜色
     */
    primaryColor: {
      type: String
    },

    /**
     * 选中项是否加粗
     */
    selectedItemBold: {
      type: Boolean,
      default: true
    },

    /**
     * 级联项选中策略；'default' 默认，只要有 defaultValue 则选中；'strict' 严格，defaultValue 必须到包含最后一列，才选中
     */
    itemSelectStrategy: {
      type: String,
      default: 'default'
    },

    /**
     * 是否是通栏
     */
    rowTile: {
      type: Boolean,
      default: false
    },

    /**
     * rowTileMargin 通栏间距
     */
    rowTileMargin: {
      type: String,
      default: '0 17px'
    },

    /**
     * 最大高度；默认为屏幕高度的 2/3；如果值 <= 1，认为是百分比；否则认为是固定 px
     */
    maxHeight: {
      type: Number,
      default: 2 / 3
    },

    /**
     * 高度；默认为 auto；如果值 <= 1，认为是百分比；否则认为是固定 px
     */
    height: {
      type: Number
    },

    /**
     * 水平 padding
     */
    filterTagLayoutPaddingHorizontal: {
      type: String,
      default: '17px'
    }
  },

  data() {
    return {
      mSelections: [],
      selectedIndex: -1,
      windowHeight: 0,
      windowWidth: 0
    };
  },

  created() {
    this.init(this.selections);
  },

  mounted() {
    // 获取系统信息
    let sysInfo = this.$api.getSystemInfoSync();
    this.windowHeight = sysInfo.windowHeight;
    this.windowWidth = sysInfo.windowWidth;
  },

  methods: {
    /**
     * 初始化数据
     *
     * @param {Array} selections 筛选数据
     */
    init(selections) {
      this.selectedIndex = -1; // 深复制数据

      this.mSelections = JSON.parse(JSON.stringify(selections));
      this.mSelections.forEach(selection => {
        // 备份原始的 text
        selection.originText = selection.text; // 级联选择器类型

        if (selection.type === 'list') {
          if (selection.defaultValue) {
            let list = [{
              key: selection.key,
              options: selection.options
            }]; // 打平数据

            this.cascaderRecursion(selection.defaultValue, selection.options, 0, null, list);
            list.forEach((item, index) => {
              let text = selection.originText;

              if (item && item.selectedIndex !== -1 && item.selectedIndex !== undefined) {
                item.options[item.selectedIndex].value;
                text = item.options[item.selectedIndex].text;
              }

              if (index === list.length - 1) {
                // 设置默认 FilterTag 文案
                this.$set(selection, 'text', text);
              }
            });
          }
        } // 多重选择器类型
        else if (selection.type === 'multi') {
            this.$set(selection, 'isCanReset', false);
            selection.options.forEach(option => {
              this.$set(option, 'selectedIndex', -1);
              let defaultValues = option.defaultValue ? option.defaultValue.split(',') : [];

              if (defaultValues.length) {
                option.options.forEach(option2 => {
                  if (defaultValues.indexOf(option2.value) !== -1) {
                    this.$set(option2, 'selected', true); // 设置为可以被重置

                    this.$set(selection, 'isCanReset', true);
                  }
                });
              }
            });
          }
      });
    },

    // Tag 项点击
    handleTagLayoutTap(obj) {
      /**
       * 标签栏点击事件
       *
       * @event taglayouttap
       *
       * @property {number} param1.lastSelectedIndex 上一次点击项的索引
       * @property {number} param1.optionIndex 当前点击项索引
       * @property {string} param1.option 当前点击项
       * @property {string} param1.defaultValue 当前点击项的默认值
       * @property {string} param1.type 当前点击项的类型
       * @property {string} param1.text 当前点击项的文案
       */
      this.$emit('taglayouttap', obj);

      if (obj.lastSelectedIndex === obj.optionIndex) {
        this.close();
      } else {
        this.selectedIndex = obj.optionIndex;
      }
    },

    // 级联项点击
    handleCascaderItemTap(e, obj) {},

    // 最后一列点击
    handleLastColumnItemTap(obj) {
      let selection = this.mSelections[this.selectedIndex];
      selection.defaultValue = obj.defaultValue;
      selection.text = obj.option.text || selection.originText;
      this.confirm();
      this.close();
    },

    handleMultiTouchStart(e) {
      if (!this.stopScrollThrough) {
        return;
      }

      this.handleTouchStartStopScrollThroughMixin(e);
    },

    handleMultiTouchMove(e) {
      if (!this.stopScrollThrough) {
        return;
      } // 此代码块里的内容只渲染到h5端


      this.handleTouchMoveStopScrollThroughMixin(e, this.$refs.multi[0].$el);
    },

    // 多重 Tags 项点击
    handleItemTap(e, obj) {
      // 多重 一级项
      let multiOption = this.mSelections[obj.selectionIndex].options[obj.optionIndex]; // 多选

      if (e.type === 'checkbox') {
        let options = multiOption.options;
        options = JSON.parse(JSON.stringify(options));

        if (multiOption.options[e.optionIndex].selected) {
          options[e.optionIndex].selected = false;
          this.$set(multiOption, 'options', options);
        } else {
          options[e.optionIndex].selected = true;
          this.$set(multiOption, 'options', options);
        }
      } // 单选
      else {
          let options = multiOption.options;
          options = JSON.parse(JSON.stringify(options));

          if (multiOption.options[e.optionIndex].selected) {
            options[e.optionIndex].selected = false;
            this.$set(multiOption, 'options', options);
          } else {
            options.forEach(option => {
              option.selected = false;
            });
            options[e.optionIndex].selected = true;
            this.$set(multiOption, 'options', options);
          }
        } // 得到当前多重选中的数据


      let resObj = {};
      let selection = this.mSelections[obj.selectionIndex];
      this.handleMultiData(selection, resObj); // 遍历所有 key，只要找到一个值被选中，就设置为可以被重置，然后直接 return

      for (let key in resObj) {
        if (resObj[key].value) {
          selection.isCanReset = true;
          return;
        }
      } // 如果一个都没找到，就设置为不可被重置


      selection.isCanReset = false;
    },

    // 多重 重置按钮点击
    handleMultiResetTap(obj) {
      let selection = this.mSelections[obj.selectionIndex]; // 清空全部选中状态

      selection.options.forEach(option => {
        let options = JSON.parse(JSON.stringify(option.options));
        options.forEach(option2 => {
          option2.selected = false;
        });
        this.$set(option, 'options', options);
      }); // 不可以被重置

      selection.isCanReset = false;
    },

    // 多重 确定按钮点击
    handleMultiConfirmTap() {
      this.confirm();
      this.close();
    },

    // 确定
    confirm() {
      let allResults = this.getResult();
      /**
       * 筛选项改变事件
       *
       * @event change
       *
       * @property {object} param1.allResults 结果对象，里面会以键值对存放最终获得到的数据
       */

      this.$emit('change', {
        allResults
      });
    },

    // 得到结果
    getResult() {
      let resultObj = {};
      this.mSelections.forEach(selection => {
        // 级联
        if (selection.type === 'list') {
          this.handleCascaderData(selection, resultObj);
        } // 多重
        else if (selection.type === 'multi') {
            this.handleMultiData(selection, resultObj);
          }
      });
      return resultObj;
    },

    // 处理级联数据
    handleCascaderData(selection, resultObj) {
      let list = [{
        key: selection.key,
        options: selection.options
      }]; // 打平数据

      this.cascaderRecursion(selection.defaultValue, selection.options, 0, null, list); // 得到键值对

      list.forEach((item, index) => {
        let key = item.key;
        let value = '';

        if (item && item.selectedIndex !== -1 && item.selectedIndex !== undefined) {
          value = item.options[item.selectedIndex].value;
        }

        list[index].value = value;
        resultObj[key] = {
          value,
          options: [item.options[item.selectedIndex]]
        };
      });
    },

    // 级联选择器递归
    cascaderRecursion(defaultValue, options, count, defaultValueArr, list) {
      if (count === undefined) {
        count = 0;
      }

      if (!options) {
        return;
      }

      if (!defaultValueArr) {
        defaultValueArr = defaultValue ? defaultValue.split(',').map(item => item.trim()) : [];
      } // 遍历找出值相等的项


      for (let i = 0; i < options.length; i++) {
        let option = options[i];
        let optionIndex = i; // 因为新设置的 defaultValue 是从级联选择器里返回的，所以是字符串，对于特殊字符，需要转换一下

        if (defaultValueArr[count] === 'null') {
          defaultValueArr[count] = null;
        } // 如果值相等


        if (option.value === defaultValueArr[count]) {
          // 设置选中
          this.$set(option, 'selected', true);
          list[count].selectedIndex = optionIndex; // 如果选中的 otpion 还有子 options 存在

          if (option && option.options) {
            // 级数加1
            count++; // 设置子 options

            this.$set(list, count, {
              options: option.options,
              key: option.key
            }); // 递归

            this.cascaderRecursion(option.defaultValue, option.options, count, defaultValueArr, list);
          }

          return;
        }
      }
    },

    // 处理多重数据
    handleMultiData(selection, resultObj) {
      selection.options.forEach(option => {
        let key = option.key;
        let value = '';
        let options = [];
        option.options.forEach(option2 => {
          if (option2.selected) {
            value += value === '' ? option2.value : ',' + option2.value;
            options.push(option2);
          }
        });
        resultObj[key] = {
          value,
          options
        };
      });
    },

    // 蒙层点击
    handleMaskTap() {
      /**
       * 蒙层点击事件
       *
       * @event masktap
       *
       * @property {object} param1.selectedIndex 蒙层点击时选择的项索引
       */
      this.$emit('masktap', {
        selectedIndex: this.selectedIndex
      });
      this.close();
    },

    // 关闭蒙层
    close() {
      // 设置为 -1
      this.selectedIndex = -1;
      /**
       * 关闭
       *
       * @event close
       */

      this.$emit('close');
    }

  },
  watch: {
    selections(newVal, oldVal) {
      this.init(newVal);
    }

  }
};
</script>

<style scoped>
.hidden {
  display: none;
}
.wrapper {
  position: relative;
  width: 100%;
}
.multi-wrapper {
  position: relative;
  background-color: #fff;
}
.multi {
  padding-bottom: 71px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  /* 兼容；如果这里直接设置为 scroll，由于 Content 组件的 el.offsetWidth 强制重绘，在 Android 上会闪动；所以需要设置为 auto */
  overflow: auto;
  /* iOS 弹性滚动 */
  -webkit-overflow-scrolling: touch;
}
.btn-layout {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 17px;
  background-color: #fff;
  border-top: 1px solid #eee;
}
.mask {
  position: absolute;
  height: 1500px;
  left: 0;
  right: 0;
}

</style>
